(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/retailer-login/assets/javascripts/login-form.js') >= 0) return;  svs.modules.push('/components/components/retailer-login/assets/javascripts/login-form.js');

'use strict';

svs.components = svs.components || {};
const logger = svs.core.log.getLogger('component:retailer-login');
function RetailerLogin(_ref) {
  let changePwdUrl = _ref.changePwdUrl,
    element = _ref.element,
    returnUrl = _ref.returnUrl,
    source = _ref.source;
  const form = element.querySelector('.js-retailer-login-form');
  const userName = element.querySelector('#loginPageUsernameTextbox');
  const password = element.querySelector('#modalPasswordTextbox');
  const showErrorMessage = error => {
    form.querySelector('.js-login-form-fieldset').classList.add('error');
    form.querySelector('.js-error-message').innerHTML = error;
  };
  const onLoginError = result => {
    let errorMessageReason = 'Unknown';
    let errorCode = -1;
    let logError = false;
    const dialogOptions = {
      title: 'Tekniskt fel',
      message: 'Var vänlig försök igen senare.',
      show: true
    };
    if (result.responseText) {
      errorCode = JSON.parse(result.responseText).error.code;
    }
    switch (errorCode) {
      case 1:
        errorMessageReason = 'Default error';
        logError = true;
        break;
      case 2: 
      case 13:
        dialogOptions.show = false;
        errorMessageReason = 'Wrong password or username';
        showErrorMessage('Fel lösenord eller användarnamn');
        password.focus();
        password.select();
        break;
      case 3:
        errorMessageReason = 'Invalid session';
        logError = true;
        break;
      case 4:
        errorMessageReason = 'Invalid session id';
        logError = true;
        break;
      case 5:
        errorMessageReason = 'Account locked. Too many login attempts';
        dialogOptions.title = 'Kontot är låst';
        dialogOptions.message = 'Ditt lösenord är nu ogiltigt p.g.a. många felaktiga inloggningsförsök.<br/>Kontakta ombudssupport 020-78 83 55';
        break;
      case 6:
        errorMessageReason = 'Account locked';
        showErrorMessage('Spärrat konto');
        dialogOptions.title = 'Inloggning misslyckades';
        dialogOptions.message = 'Ditt konto är spärrat.<br/>Vid frågor, kontakta ombudssupport 020-78 83 55';
        break;
      default:
        errorMessageReason = errorMessageReason + (result.responseText ? ". Response text: ".concat(result.responseText) : '');
        logError = true;
    }
    svs.events.publish('/loader/hide');
    if (dialogOptions.show) {
      const dialog = new svs.ui.dialog.Confirm({
        type: svs.ui.dialog.type.ERROR,
        branding: svs.ui.dialog.branding.NEUTRAL,
        area: svs.ui.dialog.area.POPUP,
        title: dialogOptions.title,
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: dialogOptions.message
        }],
        actions: [{
          title: 'Stäng'
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
    if (logError) {
      logger.error("Login failed. Code:".concat(errorCode, " Reason:").concat(errorMessageReason));
    }
  };
  const onLoginSuccess = result => {
    const _result$userNotificat = result.userNotifications,
      _result$userNotificat2 = _result$userNotificat === void 0 ? {} : _result$userNotificat,
      mustChangePwd = _result$userNotificat2.REDIRECT;
    if (mustChangePwd) {
      RetailerLogin.redirect("".concat(changePwdUrl, "?returnUrl=").concat(returnUrl));
      return;
    }
    svs.components.Storage.browser.set('alias', 'retailerLogin', userName.value, svs.components.Storage.constants.EXPIRES_1YEAR, () => {
      svs.events.publish('/loader/hide');
      saveLastLoginTime(result.lastLoginTime, () => {
        saveUserNotifications(result.userNotifications, () => {
          saveSequenceNumber(result.sequenceNum, () => RetailerLogin.redirect(returnUrl));
        });
      });
    });
  };

  const saveLastLoginTime = (lastLoginTime, cb) => {
    if (lastLoginTime) {
      svs.core.deviceSession.set('lastLoginTime', null, lastLoginTime, cb);
    } else if (Object.prototype.hasOwnProperty.call(svs.core.session.data.session, 'lastLoginTime')) {
      svs.core.deviceSession.remove('lastLoginTime', null, cb);
    } else {
      cb();
    }
  };

  const saveUserNotifications = (notif, cb) => {
    if (notif && notif.REDIRECT) {
      svs.core.deviceSession.set('userNotifications', null, {
        redirect: true
      }, cb);
    } else if (Object.prototype.hasOwnProperty.call(svs.core.session.data.session, 'userNotifications')) {
      svs.core.deviceSession.remove('userNotifications', null, cb);
    } else {
      cb();
    }
  };

  const saveSequenceNumber = (sequenceNum, cb) => {
    if (sequenceNum) {
      svs.core.deviceSession.set('sequencenumber', null, sequenceNum, cb);
    } else if (Object.prototype.hasOwnProperty.call(svs.core.session.data.session, 'sequencenumber')) {
      svs.core.deviceSession.remove('sequencenumber', null, cb);
    } else {
      cb();
    }
  };
  const submitLogin = e => {
    e.preventDefault();
    svs.events.publish('/loader/show');
    const options = {
      path: '/retailer/1/sessions/webterminal',
      data: {
        userName: userName.value,
        password: password.value,
        source
      },
      useExtErrFunc: false
    };
    svs.core.jupiter.post(options, onLoginSuccess, onLoginError);
  };
  form.addEventListener('submit', submitLogin);

  svs.components.Storage.browser.get('alias', 'retailerLogin', alias => {
    if (alias) {
      userName.value = alias;
      password.focus();
    } else {
      svs.components.Storage.browser.get('internalAlias', 'svs.components.login', internalAlias => {
        if (internalAlias) {
          userName.value = internalAlias;
          password.focus();
        } else {
          userName.focus();
        }
      });
    }
  });
}
RetailerLogin.redirect = url => {
  window.location.replace(url);
};
svs.components.RetailerLogin = RetailerLogin;

 })(window);